import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { map } from 'rxjs';
import { injectTranslator } from '../../providers/i18n';
import { TrinityAuthService } from './trinity.auth.service';

@Component({
  selector: 'lib-auth',
  imports: [ReactiveFormsModule, MatDialogModule, MatButtonModule, MatIconModule, MatInputModule],
  templateUrl: './auth.dialog.html',
  styleUrl: './auth.dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'data-testid': 'auth-dialog-container' },
})
export default class AuthDialog {
  private auth = inject(TrinityAuthService);
  private ref = inject(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);
  protected translate = injectTranslator('common');

  protected login = () => this.auth.authenticate(this.$logged() ? 'google_domain_admin' : 'google_domain_user');
  protected impersonate = () =>
    this.emailControl.valid && this.auth.impersonate(this.emailControl.value).subscribe(() => this.ref.close(true));
  protected emailControl = new FormControl('', {
    nonNullable: true,
    validators: [Validators.email, Validators.required],
  });

  protected $logged = toSignal(this.auth.user$.pipe(map(Boolean)));
  protected $superuser = toSignal(this.auth.user$.pipe(map((u) => u?.roles.includes('overlayer_super_user'))));
}
